<ion-tab-bar *ngIf="isMobile" slot="bottom" class="mobile-tab-bar">
  <ion-tab-button 
    *ngFor="let tab of tabs"
    [routerLink]="(tab.isMenuButton || tab.isFoodButton) ? null : tab.url"
    (click)="handleTabClick(tab, $event)"
    [class.active]="!tab.isMenuButton && !tab.isFoodButton && isActive(tab.url)"
    [class.menu-button]="tab.isMenuButton"
    [class.food-button]="tab.isFoodButton"
    #menuButton>
    <ion-icon [name]="tab.icon"></ion-icon>
    <ion-label>{{tab.title}}</ion-label>
  </ion-tab-button>
</ion-tab-bar>

